import React, { useState, useEffect } from "react";
import {
  Form,
  FormGroup,
  FormInput,
  FormTextarea,
  Button,
  Row,
  Col,
  Container,
} from "shards-react";
import styled from "styled-components";
import Layout from "shared/container/LayoutAdmin";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileLines } from "@fortawesome/free-regular-svg-icons";

const lawContent = styled.div`
  padding: 30px 0;
  cursor: pointer;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;

  @media only screen and (max-width: 786px) {
    flex-direction: column;
    & a {
      flex: 1;
      margin: 10px 0;
    }
  }
`;
const StyledVDO = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 15px 15px 30px;
  & iframe {
    max-width: 100%;
  }
`;

const StyledMedia = styled.a`
  display: flex;
  align-items: center;
  color: #000;
  margin-bottom: 10px;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  padding: 5px 20px;
  .media-icon {
    padding: 20px;
    svg {
      height: 45px;
    }
  }
  .media-body-title {
    font-weight: bold;
    margin-bottom: 10px;
  }
  .media-body-subtitle {
    color: #818181;
  }
  .media-body {
    line-height: 2.5rem;
    margin-right: 20px;
  }
  .file {
    svg {
      margin-top: 5px;
      height: 35px;
      color: #868e96;
    }
  }
`;

const Manual = (props) => {
  const { t, i18n } = useTranslation();

  return (
    <>
      <Layout>
        <Container>
          <Row>
            <Col className="mt-5 mb-5 text-center">
              <h5 className="mb-2">
                <strong>คู่มือการใช้งาน</strong>
              </h5>
            </Col>
          </Row>
          <Row style={{ paddingBottom: 10 }}>
            <Col md="12">
              <lawContent>
                <StyledMedia
                  className="media"
                  download
                  href="/manualDocument/05_guest.pdf"
                  target="_blank"
                >
                  <div className="media-body">
                    <div>1. คู่มือการใช้งานของผู้ใช้งานทั่วไป</div>
                  </div>
                  <a className="file">
                    <FontAwesomeIcon icon={faFileLines} />
                  </a>
                </StyledMedia>
                <StyledMedia
                  className="media"
                  download
                  href="/manualDocument/04_member.pdf"
                  target="_blank"
                >
                  <div className="media-body">
                    <div>2. คู่มือการใช้งานของสมาชิก</div>
                  </div>
                  <a className="file">
                    <FontAwesomeIcon icon={faFileLines} />
                  </a>
                </StyledMedia>
                <StyledMedia
                  className="media"
                  download
                  href="/manualDocument/03_input.pdf"
                  target="_blank"
                >
                  <div className="media-body">
                    <div>3. คู่มือการใช้งานของผู้นำเข้าข้อมูล</div>
                  </div>
                  <a className="file">
                    <FontAwesomeIcon icon={faFileLines} />
                  </a>
                </StyledMedia>
                <StyledMedia
                  className="media"
                  download
                  href="/manualDocument/02_approve.pdf"
                  target="_blank"
                >
                  <div className="media-body">
                    <div>
                      4. คู่มือการใช้งานของผู้ตรวจสอบและผู้อนุมัติข้อมูล
                    </div>
                  </div>
                  <a className="file">
                    <FontAwesomeIcon icon={faFileLines} />
                  </a>
                </StyledMedia>
                <StyledMedia
                  className="media"
                  download
                  href="/manualDocument/01_admin.pdf"
                  target="_blank"
                >
                  <div className="media-body">
                    <div>5. คู่มือการใช้งานของผู้ดูแลระบบ</div>
                  </div>
                  <a className="file">
                    <FontAwesomeIcon icon={faFileLines} />
                  </a>
                </StyledMedia>
              </lawContent>
            </Col>
          </Row>
          <Row>
            <Col className="mt-5 mb-5 text-center">
              <h5 className="mb-2">
                <strong>วีดีโอคู่มือการใช้งานส่วนต่างๆ สำหรับสมาชิก</strong>
              </h5>
            </Col>
          </Row>
          <Row style={{ paddingBottom: 10 }}>
            <Col md="6">
              <h4 style={{ fontSize: 16 }}>1. คู่มือการใช้งานหน้าหลัก</h4>
              <StyledVDO>
                <iframe
                  width="520"
                  height="293"
                  src="https://www.youtube.com/embed/xqC1mUJAu28?controls=0"
                  title="1. คู่มือการใช้งานหน้าหลัก"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </StyledVDO>
            </Col>
            <Col md="6">
              <h4 style={{ fontSize: 16 }}>
                2. คู่มือการใช้งานการลงทะเบียนและเข้าสู่ระบบ
              </h4>
              <StyledVDO>
                <iframe
                  width="520"
                  height="293"
                  src="https://www.youtube.com/embed/GfJHJxq3US0?controls=0"
                  title="การลงทะเบียนและเข้าสู่ระบบ"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </StyledVDO>
            </Col>
            <Col md="6">
              <h4 style={{ fontSize: 16 }}>
                3. คู่มือการใช้งานการจัดการข้อมุลส่วนตัว ติดต่อผู้ดูแลระบบ
              </h4>
              <StyledVDO>
                <iframe
                  width="520"
                  height="293"
                  src="https://www.youtube.com/embed/k4xaY9iogXM?controls=0"
                  title="การจัดการข้อมุลส่วนตัว ติดต่อผู้ดูแลระบบ"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </StyledVDO>
            </Col>
            <Col md="6">
              <h4 style={{ fontSize: 16 }}>
                4. คู่มือการใช้งานการนำเข้าข้อมูลตัวชี้วัด
              </h4>
              <StyledVDO>
                <iframe
                  width="520"
                  height="293"
                  src="https://www.youtube.com/embed/93RJO_1qx8U?controls=0"
                  title="การนำเข้าข้อมูลตัวชี้วัด"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </StyledVDO>
            </Col>
            <Col md="6">
              <h4 style={{ fontSize: 16 }}>
                5. คู่มือการใช้งานการจัดการข้อมูลและการอนุมัติเผยแพร่ตัวชี้วัด
              </h4>
              <StyledVDO>
                <iframe
                  width="520"
                  height="293"
                  src="https://www.youtube.com/embed/aOMWkNRrzPY?controls=0"
                  title="การจัดการข้อมูลและการอนุมัติเผยแพร่ตัวชี้วัด"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </StyledVDO>
            </Col>
          </Row>

          <Row>
            <Col className="mt-5 mb-5 text-center">
              <h5 className="mb-2">
                <strong>
                  วีดีโอคู่มือการใช้งานส่วนต่างๆ สำหรับผู้ดูแลระบบ
                </strong>
              </h5>
            </Col>
          </Row>
          <Row style={{ paddingBottom: 50 }}>
            <Col md="6">
              <h4 style={{ fontSize: 16 }}>
                1. คู่มือการใช้งานการจัดการผู้ใช้งาน
              </h4>
              <StyledVDO>
                <iframe
                  width="520"
                  height="293"
                  src="https://www.youtube.com/embed/bGgFKhJwOxo?controls=0"
                  title="การจัดการผู้ใช้งาน"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </StyledVDO>
            </Col>
            <Col md="6">
              <h4 style={{ fontSize: 16 }}>
                2. คู่มือการใช้งานการจัดการคำอธิบายข้อมูลตัวชี้วัด
              </h4>
              <StyledVDO>
                <iframe
                  width="520"
                  height="293"
                  src="https://www.youtube.com/embed/ClhLDR1sWl4?controls=0"
                  title="การจัดการคำอธิบายข้อมูลตัวชี้วัด"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </StyledVDO>
            </Col>
            <Col md="6">
              <h4 style={{ fontSize: 16 }}>
                3. คู่มือการใช้งานการจัดการหน้าหลัก
              </h4>
              <StyledVDO>
                <iframe
                  width="520"
                  height="293"
                  src="https://www.youtube.com/embed/5xaqS6iZPSw?controls=0"
                  title="การจัดการหน้าหลัก"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </StyledVDO>
            </Col>
            <Col md="6">
              <h4 style={{ fontSize: 16 }}>
                4. คู่มือการใช้งานการจัดการแบบสอบถามข้อมูล
              </h4>
              <StyledVDO>
                <iframe
                  width="520"
                  height="293"
                  src="https://www.youtube.com/embed/_J5r3RbmVVQ?controls=0"
                  title="การจัดการแบบสอบถามข้อมูล"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </StyledVDO>
            </Col>
            <Col md="6">
              <h4 style={{ fontSize: 16 }}>
                5. คู่มือการใช้งานการจัดการแจ้งเตือนอีเมล
              </h4>
              <StyledVDO>
                <iframe
                  width="520"
                  height="293"
                  src="https://www.youtube.com/embed/q-rLkcH0W2w?controls=0"
                  title="การจัดการแจ้งเตือนอีเมล"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </StyledVDO>
            </Col>
            <Col md="6">
              <h4 style={{ fontSize: 16 }}>6. คู่มือการใช้งานรายงาน</h4>
              <StyledVDO>
                <iframe
                  width="520"
                  height="293"
                  src="https://www.youtube.com/embed/5-iwl31yVoU?controls=0"
                  title="คู่มือการใช้งานรายงาน"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </StyledVDO>
            </Col>
          </Row>
        </Container>
      </Layout>
    </>
  );
};

export default Manual;
